import _ from "lodash"
import { AnyAction, combineReducers, Reducer } from "redux"
import { INormalizedEntities } from "../../../../app/appTypes"
import { CaseSourceActionTypes, ICaseSource } from "../caseSourceTypes"

type TByIdState = { [id: string]: ICaseSource }
type TAllIdsState = string[]

export const byIdInitialState: TByIdState = {}
export const allIdsInitialState: TAllIdsState = []

export const byId: Reducer<TByIdState> = (state: TByIdState = byIdInitialState, action: AnyAction): TByIdState => {
  switch(action.type) {
    case CaseSourceActionTypes.FETCH_CASE_SOURCES_ASYNC_SUCCESS:
      return  {
        ...state,
        ...action.payload.entities.caseSources
      }
    default:
      return {...state}
  }
}

export const allIds: Reducer<TAllIdsState> = (state: TAllIdsState = allIdsInitialState, action: AnyAction): TAllIdsState => {
  switch(action.type) {
    case CaseSourceActionTypes.FETCH_CASE_SOURCES_ASYNC_SUCCESS:
      return _.uniq(_.concat(state, action.payload.result))
    default:
      return state
  }
}

export const caseSourceEntityReducer: Reducer<INormalizedEntities<ICaseSource>> = combineReducers({
  byId,
  allIds
})
